var parent = require('../../es/weak-map');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/weak-map/index.js
// module id = 557
// module chunks = 0 1